import React, { Component } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import * as styles from './editQuestionsRadio.style';
import { cx } from '@emotion/css';
import { title } from './questionWithTextFeild.style';
import MathParser from './MathParser';
import 'mathlive';
import '../assets/googleradio.css';
import { convertLatexToQuillHtml } from './EditQuestionswithTextfield';

class EditQuestionwithRadio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      question: this.props.question || '',
      questionHtml: convertLatexToQuillHtml(this.props.question || ''),
      correctanswer: this.props.correctanswer || '',
      subcategory: this.props.subcategory || '',
      choice1: this.props.answer ? this.props.answer[0] : '',
      choice1Html: convertLatexToQuillHtml(this.props.answer ? this.props.answer[0] : ''),
      choice2: this.props.answer ? this.props.answer[1] : '',
      choice2Html: convertLatexToQuillHtml(this.props.answer ? this.props.answer[1] : ''),
      choice3: this.props.answer ? this.props.answer[2] : '',
      choice3Html: convertLatexToQuillHtml(this.props.answer ? this.props.answer[2] : ''),
      choice4: this.props.answer ? this.props.answer[3] : '',
      choice4Html: convertLatexToQuillHtml(this.props.answer ? this.props.answer[3] : ''),
      showBuilder: false,
      activeInput: null,
      mathBuilderValue: '',
    };

    this.quillRefs = {
      question: React.createRef(),
      choice1: React.createRef(),
      choice2: React.createRef(),
      choice3: React.createRef(),
      choice4: React.createRef()
    };
    
    this.mathFieldRef = React.createRef();

    this.quillModules = {
      toolbar: false,
      formula: true,
    };
  }

  getRawText(editor) {
    const delta = editor.getContents();
    let text = '';
    if (delta && delta.ops) {
      delta.ops.forEach(op => {
        if (typeof op.insert === 'string') {
          text += op.insert;
        } else if (op.insert && op.insert.formula) {
          text += `$${op.insert.formula}$`;
        }
      });
    }
    if (text.endsWith('\n')) {
      text = text.slice(0, -1);
    }
    return text;
  }

  handleMathInput = (e) => {
    this.setState({ mathBuilderValue: e.target.value });
  };

  toggleBuilder = (e, field) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    if (this.state.showBuilder && this.state.activeInput === field) {
      this.setState({ showBuilder: false, activeInput: null }, () => {
        if (this.mathFieldRef.current) {
          this.mathFieldRef.current.removeEventListener('input', this.handleMathInput);
        }
      });
    } else {
      this.setState({ showBuilder: true, activeInput: field, mathBuilderValue: '' }, () => {
        if (this.mathFieldRef.current) {
          this.mathFieldRef.current.addEventListener('input', this.handleMathInput);
          this.mathFieldRef.current.focus();
        }
      });
    }
  };

  insertMath = () => {
    const activeField = this.state.activeInput;
    if (!activeField) return;
    
    const quillRef = this.quillRefs[activeField];
    if (!quillRef.current) return;
    
    const editor = quillRef.current.getEditor();
    const range = editor.getSelection(true);
    const index = range ? range.index : editor.getLength();
    
    editor.insertEmbed(index, 'formula', this.state.mathBuilderValue);
    editor.setSelection(index + 1);

    this.setState({ showBuilder: false, activeInput: null }, () => {
      if (this.mathFieldRef.current) {
        this.mathFieldRef.current.removeEventListener('input', this.handleMathInput);
      }
    });
  };

  componentWillUnmount() {
    if (this.mathFieldRef.current) {
      this.mathFieldRef.current.removeEventListener('input', this.handleMathInput);
    }
  }

  componentDidUpdate(prevProps) {
    // We intentionally do NOT sync question or correctanswer from props here
    // to prevent cursor reset issues, same as EditQuestionswithTextfield.jsx
  }

  handleQuestionChange = (content, delta, source, editor) => {
    const rawText = this.getRawText(editor);
    this.setState({ questionHtml: content, question: rawText }, () => {
      this.props.selectedanswer(this.state.question, this.state.correctanswer, [
        this.state.choice1,
        this.state.choice2,
        this.state.choice3,
        this.state.choice4,
      ]);
    });
  };

  handleChoiceChange = (field, content, delta, source, editor) => {
    const rawText = this.getRawText(editor);
    const htmlField = `${field}Html`;
    const oldRawText = this.state[field];
    
    let newCorrect = this.state.correctanswer;
    if (String(this.state.correctanswer) === String(oldRawText) && this.state.correctanswer !== '') {
      newCorrect = rawText;
    }
    
    this.setState({ 
      [htmlField]: content, 
      [field]: rawText,
      correctanswer: newCorrect
    }, () => {
      this.props.selectedanswer(this.state.question, this.state.correctanswer, [
        this.state.choice1,
        this.state.choice2,
        this.state.choice3,
        this.state.choice4,
      ]);
    });
  };

  handleCorrectAnswerChange = (event) => {
    const newCorrect = event.target.value;
    this.setState({ correctanswer: newCorrect }, () => {
      this.props.selectedanswer(this.state.question, this.state.correctanswer, [
        this.state.choice1,
        this.state.choice2,
        this.state.choice3,
        this.state.choice4,
      ]);
    });
  }
  
  handleAnswer = (e) => {
    this.handleCorrectAnswerChange(e);
  };

  deletequestion() {
    // delete
  }

  renderChoiceEditor(choiceNum, choiceField) {
    const htmlField = `${choiceField}Html`;
    const choiceRawText = this.state[choiceField];
    const isCorrect = String(this.state.correctanswer) === String(choiceRawText) && this.state.correctanswer !== "";
    
    return (
      <div className="col" style={{ flex: '1 1 45%', padding: '0 10px', marginBottom: '20px' }}>
        <div className="form-group" style={{ marginBottom: 0 }}>
          <label className="label" htmlFor="" style={{ fontWeight: '600', fontSize: '14px', color: '#334155', marginBottom: '8px', display: 'block' }}>Choice {choiceNum}:</label>
          <div className="flex" style={{ display: 'flex', alignItems: 'stretch', gap: '10px' }}>
            <label className="c-input" style={{ display: 'flex', alignItems: 'center', width: '20px', flexShrink: 0, margin: 0 }}>
              <input
                onChange={this.handleAnswer}
                type="radio"
                name="correct"
                value={choiceRawText}
                checked={isCorrect}
                style={{ accentColor: '#f97316', width: '18px', height: '18px', cursor: 'pointer' }}
              />
              <span className="checkmark" style={{ display: 'none' }} />
            </label>
            <div style={{ flex: 1, backgroundColor: '#fcfcfc', borderRadius: '12px', border: '1px solid #e2e8f0', padding: '5px' }}>
              <ReactQuill
                ref={this.quillRefs[choiceField]}
                theme="snow"
                value={this.state[htmlField]}
                onChange={(content, delta, source, editor) => this.handleChoiceChange(choiceField, content, delta, source, editor)}
                modules={this.quillModules}
                style={{ border: 'none' }}
              />
            </div>
            <div style={{ display: 'inline-block', marginLeft: '6px' }}>
              <button 
                type="button"
                onClick={(e) => this.toggleBuilder(e, choiceField)}
                title="Toggle Math Equation Builder"
                style={{ 
                  background: '#f97316', 
                  border: 'none', 
                  borderRadius: '12px', 
                  padding: '0 16px', 
                  height: '100%',
                  cursor: 'pointer',
                  boxShadow: '0 4px 15px rgba(249,115,22,0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'background 0.2s'
                }}
              >
                <span style={{ fontSize: '22px', color: '#fff' }}>⌨️</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const choices = [
      { text: this.state.choice1, id: 'choice1' },
      { text: this.state.choice2, id: 'choice2' },
      { text: this.state.choice3, id: 'choice3' },
      { text: this.state.choice4, id: 'choice4' }
    ];

    return (
      <div className="questionBox" style={{ padding: '30px', backgroundColor: '#fcfaf6', borderRadius: '10px', display: 'flex', gap: '40px', border: '1px solid #e2e8f0', boxShadow: '0 5px 15px rgba(0,0,0,0.03)', flexWrap: 'wrap', alignItems: 'flex-start' }}>
        
        {/* ================= LEFT: IMMERSIVE STUDENT PREVIEW ================= */}
        <div style={{ 
          flex: '1 1 400px',
          border: '1px solid #f0ebe1', 
          borderRadius: '20px', 
          padding: '30px', 
          backgroundColor: '#fff',
          position: 'relative',
          boxShadow: '0 8px 25px rgba(0,0,0,0.02)',
          display: 'flex',
          flexDirection: 'column',
          gap: '25px'
        }}>
          <div style={{ 
            position: 'absolute', 
            top: '-14px', 
            left: '20px', 
            backgroundColor: '#ffedd5', 
            color: '#d97706', 
            padding: '6px 16px', 
            borderRadius: '20px',
            fontSize: '11px',
            fontWeight: '800',
            letterSpacing: '1px',
            textTransform: 'uppercase',
          }}>
            Live Student Preview
          </div>

          <div className="leftpanel">
            <h2 className={cx(title)} style={{ margin: '10px 0 20px', textAlign: 'left' }}>
              <span style={{ color: '#f97316', fontSize: '32px', fontWeight: '800' }}>Q{this.props.questionnumber || 1}</span><span style={{ fontSize: '24px', color: '#94a3b8', fontWeight: 'bold' }}>/{this.props.totalquestions || 5}</span>
            </h2>
            <div className="s-title" style={{ fontSize: '1.2rem', marginTop: '10px', color: '#334155', fontWeight: '500' }}>
              <MathParser text={this.state.question || 'Type a question to see the preview...'} />
            </div>
          </div>

          <div className="rightpanel" style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '10px' }}>
            <p className="s-title" style={{ fontWeight: '700', color: '#334155', fontSize: '14px', marginBottom: '8px' }}>Select Answer Below</p>
            {choices.map((choice, index) => (
              <label 
                key={index}
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  padding: '12px 15px', 
                  border: '1px solid #e2e8f0', 
                  borderRadius: '6px',
                  backgroundColor: '#fff',
                  cursor: 'pointer'
                }}
              >
                <div style={{ marginRight: '15px', display: 'flex', alignItems: 'center' }}>
                  <input
                    type="radio"
                    disabled
                    checked={String(this.state.correctanswer) === String(choice.text) && this.state.correctanswer !== ""}
                    style={{ accentColor: '#f97316', width: '16px', height: '16px' }}
                  />
                </div>
                <div style={{ color: '#475569', fontSize: '14px', fontWeight: '500' }}>
                  <MathParser text={choice.text || `Choice ${index + 1}`} />
                </div>
              </label>
            ))}
          </div>
        </div>
        {/* ============================================================ */}

        {/* ================= RIGHT: EDITOR SECTION ================= */}
        <div className={styles.form} style={{ flex: '1 1 400px', padding: '0 5px', position: 'relative' }}>

          
          {/* Math Builder Overlay */}
          {this.state.showBuilder && (
            <div 
              style={{
                position: 'absolute',
                top: '0',
                right: '0',
                zIndex: 1000,
                backgroundColor: '#ffffff',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                padding: '16px',
                boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.1)',
                width: '100%',
                maxWidth: '400px'
              }}
            >
              <div style={{ marginBottom: '12px', fontWeight: '600', fontSize: '15px', color: '#475569', display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '8px' }}>⌨️</span> Math Equation Builder
              </div>
              <math-field
                ref={this.mathFieldRef}
                style={{ 
                  width: '100%',
                  fontSize: '1.2rem',
                  padding: '10px',
                  backgroundColor: '#f8fafc',
                  border: '1px solid #cbd5e1',
                  borderRadius: '6px',
                  color: '#0f172a',
                  outline: 'none'
                }}
              >
                {this.state.mathBuilderValue}
              </math-field>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px', gap: '10px' }}>
                <button 
                  type="button"
                  onClick={() => this.setState({ showBuilder: false, activeInput: null })}
                  style={{ padding: '8px 16px', borderRadius: '6px', border: '1px solid #cbd5e1', background: '#fff', color: '#64748b', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}
                >
                  Cancel
                </button>
                <button 
                  type="button"
                  onClick={this.insertMath}
                  style={{ padding: '8px 16px', borderRadius: '6px', border: 'none', background: '#f97316', color: '#fff', cursor: 'pointer', fontSize: '13px', fontWeight: '600', boxShadow: '0 2px 4px rgba(249, 115, 22, 0.3)' }}
                >
                  Insert into {this.state.activeInput === 'question' ? 'Question' : 'Choice'}
                </button>
              </div>
            </div>
          )}

          {/* Question Editor */}
          <div className="form-group" style={{ marginBottom: '25px' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
              <i className="bx bxs-pencil" style={{ color: '#f97316', fontSize: '20px', marginRight: '8px' }}></i>
              <strong style={{ color: '#1e293b', fontSize: '16px' }}>Edit Question:</strong>
            </div>
            <div style={{ display: 'flex', alignItems: 'stretch' }}>
              <div style={{ flex: 1, backgroundColor: '#fff', borderRadius: '12px', border: '2px solid #f97316', padding: '5px' }}>
                <ReactQuill
                  ref={this.quillRefs.question}
                  theme="snow"
                  value={this.state.questionHtml}
                  onChange={this.handleQuestionChange}
                  modules={this.quillModules}
                  placeholder="Type your question here..."
                  style={{ border: 'none' }}
                />
              </div>
              <div style={{ marginLeft: '12px' }}>
                <button 
                  type="button"
                  onClick={(e) => this.toggleBuilder(e, 'question')}
                  title="Toggle Math Equation Builder"
                  style={{ 
                    background: '#f97316', 
                    border: 'none', 
                    borderRadius: '12px', 
                    padding: '0 16px',
                    height: '100%',
                    cursor: 'pointer',
                    boxShadow: '0 4px 15px rgba(249,115,22,0.3)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <span style={{ fontSize: '22px', color: '#fff' }}>⌨️</span>
                </button>
              </div>
            </div>
          </div>

          {/* Choices Editor */}
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px', marginTop: '20px' }}>
            <i className="bx bxs-check-circle" style={{ color: '#f97316', fontSize: '20px', marginRight: '8px' }}></i>
            <strong style={{ color: '#1e293b', fontSize: '16px' }}>Edit Choices (Select radio to set correct answer):</strong>
          </div>
          
          <div className="row" style={{ display: 'flex', flexWrap: 'wrap', margin: '0 -10px' }}>
            {this.renderChoiceEditor(1, 'choice1')}
            {this.renderChoiceEditor(2, 'choice2')}
          </div>
          <div className="row" style={{ display: 'flex', flexWrap: 'wrap', margin: '0 -10px' }}>
            {this.renderChoiceEditor(3, 'choice3')}
            {this.renderChoiceEditor(4, 'choice4')}
          </div>
          
        </div>
        {/* ================================================== */}
      </div>
    );
  }
}

export default EditQuestionwithRadio;
